import axios from "axios";
import url from "../../helpers/url";

async function HandleSubmit({ userInfo, user, dish, add_to_cart }) {
  const response = await axios
    .put(
      `${url}/users/${userInfo.id}`,
      {
        cart: add_to_cart(dish),
      },
      {
        headers: {
          Authorization: `Bearer ${user.token}`,
        },
      }
    )
    .catch(() => {
      console.clear();
    });
  return response;
}

export default HandleSubmit;
